import { combineReducers } from "redux";
import ProfileReducer from "./profile/reducer";
import CommonReducer from "./common/reducer";
import NotificationReducer from "./notification/reducer";
import TranslationReducer from "./translation/reducer";
import ReferralRewardReducer from "./referral-reward/reducer";
import CourseReducer from "./course/reducer";
import AssignmentReducer from "./assignment/reducer";
import AdditionalProblemReducer from "./additional-problem/reducer";
import LeaderboardReducer from "./leader-board/reducer";
import AuthReducer from "./auth/reducer";
import DiscussionHubReducer from "./discussion-hub/reducer";
import DashboardReducer from "./dashboard/reducer";

const rootReducer = combineReducers({
    Profile: ProfileReducer,
    Common: CommonReducer,
    Notification: NotificationReducer,
    Translation: TranslationReducer,
    ReferralReward: ReferralRewardReducer,
    Course: CourseReducer,
    Assignment: AssignmentReducer,
    AdditionalProblem: AdditionalProblemReducer,
    LeaderBoard: LeaderboardReducer,
    Auth: AuthReducer,
    DiscussionHub: DiscussionHubReducer,
    Dashboard: DashboardReducer
});

export default rootReducer;